"use strict";
/**
 * @module Services.SessionFetchQuery
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a SESSION_FETCH_QUERY request.
 */
var SessionFetchQuery = /** @class */ (function () {
    /**
     * Create a new SessionFetchQueryResult instance
     *
     * @param filter  the session filter
     * @param range  the fetch range
     * @param withProperties  which session properties to return
     * @param limit  the limit on the number of results returned
     * @param maximumResultSize  the maximum result size
     */
    function SessionFetchQuery(filter, range, withProperties, limit, maximumResultSize, requiresStartTime) {
        this.filter = filter;
        this.range = range;
        this.withProperties = withProperties;
        this.limit = limit;
        this.maximumResultSize = maximumResultSize;
        this.requiresStartTime = requiresStartTime;
    }
    return SessionFetchQuery;
}());
exports.SessionFetchQuery = SessionFetchQuery;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-fetch-query/session-fetch-query.js
// module id = 1982
// module chunks = 1